import axios from 'axios';
import { publicPaths } from './authConstants';
import authService from './authService';

export function setupAxiosInterceptor() {
  axios.interceptors.request.use(
    async (config) => {
      config.headers = config.headers ?? {};

      // Skip token attachment for unauthenticated endpoints
      const langCode = localStorage.getItem('lang') || 'en';
      config.headers['lang-code'] = langCode;
      const isPublic = publicPaths.some((path) => config.url?.includes(path));

      if (!isPublic && authService.isAuthenticated()) {
        try {
          const token = await authService.getAccessToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.warn('[Axios Interceptor] Token acquisition failed, proceeding without token:', error);
        }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor: centralize crossover handling for ANY API call.
  // If the backend signals a no-access "crossover" case (unlinked, deleted,
  // or deactivated AD B2C user), perform a hard external redirect. This is
  // intentionally NOT an authService.logout() call, to avoid triggering B2C SLO.
  axios.interceptors.response.use(
    (response) => {
      // If the backend returns a NoAccessURL in any successful response,
      // perform a hard external redirect immediately.
      const noAccessUrl = response?.data?.data?.crossover?.redirect_url;
      if (noAccessUrl) {
        authService.clearLocalSession().finally(() => {
            window.location.replace(noAccessUrl);
        });
        return new Promise(() => { }); // navigating away; never resolve/reject
      }
      return response;
    },
    (error) => {
      const noAccessUrl = error.response?.data?.data?.crossover?.redirect_url;

      // Crossover redirect (unlinked / deactivated B2C user)
      if (noAccessUrl) {
        const err = new Error("Redirecting to no-access page");
        err.isNoAccessRedirect = true;
        authService.clearLocalSession().finally(() => {
          window.location.replace(noAccessUrl);
        });
      }

      return Promise.reject(error);
    }
  );
}
